import { render, staticRenderFns } from "./ErrorAutenticate.vue?vue&type=template&id=4b5a8d12&scoped=true&lang=pug&"
import script from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
export * from "./ErrorAutenticate.vue?vue&type=script&lang=js&"
import style0 from "./ErrorAutenticate.vue?vue&type=style&index=0&id=4b5a8d12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5a8d12",
  null
  
)

export default component.exports